/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_Free_Shipping_YesInputs */

const vi_shop_tier_free_shipping_yes = /** @type {(inputs: Shop_Tier_Free_Shipping_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có`)
};

/**

* @param {Shop_Tier_Free_Shipping_YesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_free_shipping_yes = /** @type {((inputs?: Shop_Tier_Free_Shipping_YesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Free_Shipping_YesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_free_shipping_yes(inputs)
});